import axios from 'axios';
import { IFillerImage } from 'src/infrastructure/interfaces';

export default class FillerImageService {

    static editFillerImage(fillerImage: IFillerImage, formData?: FormData) {
        if (formData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/fillerImageImage',
                        formData,
                        { headers: {'Content-Type': 'multipart/form-data' }})
                    .then((res) => {
                        const src = res.data.file;
                        fillerImage.src = src;
                        axios.put(`/fillerImage/${fillerImage.id}`, fillerImage)
                            .then((res) => {
                                resolve(res.data);
                            })
                            .catch(error => reject(error));
                    })
            });
        } else {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/fillerImage/${fillerImage.id}`, fillerImage)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(error => reject(error));
            });
        }
    }

    static createFillerImage(iconName: string, formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .post('/fillerImageImage',
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    const src = res.data.file;
                    axios
                        .post('/fillerImage', { name: iconName, src })
                        .then((res) => {
                            resolve(res.data);
                        })
                })
                .catch(error => reject(error));
        });
    }

    static deleteFillerImage(fillerImage: IFillerImage) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/fillerImage/${fillerImage.id}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/FillerImageService.ts